import { FC } from "react";
import { useTranslation } from "react-i18next";
import CustomTabPane, { TabProps } from "@/components/TabPane";
import CustomerTable from "./components/SupplierList";
import SDoc from "@/components/SDoc";
import SCustomerPrice from "./pages/Price/PriceList";
import { Supplier } from "@/types/purchase";
import SupplierUserList from "./pages/User/UserList";
import InventoryOrder from "@/SupplierPages/Home/InventoryOrder";

export type CustomerTabType = 'price' | 'doc' | 'user' | 'delivery' | 'priceDoc'

const PurchaseHome: FC = () => {
  const { t } = useTranslation();

  const keyObj: (supplier: Supplier) => { [key in CustomerTabType]: TabProps } = (supplier) => ({
    doc: {
      key: 'doc',
      label: (supplier.shortName || supplier.code) + ' ' + t('purchase.documents'),
      children: <SDoc docId={supplier.docId} />
    },
    price: {
      key: 'price',
      label: (supplier.shortName || supplier.code) + ' ' + t('purchase.priceDetail'),
      children: <SCustomerPrice supplier={supplier} />,
    },
    priceDoc: {
      key: 'priceDoc',
      label: (supplier.shortName || supplier.code) + ' ' + (supplier as any).proCode! + ' ' + t('purchase.priceDetail'),
      children: <SDoc docId={supplier.docId} />,
    },
    user: {
      key: 'user',
      label: (supplier.shortName || supplier.code) + ' ' + t('purchase.userList'),
      children: <SupplierUserList supplier={supplier} />,
    },
    delivery: {
      key: 'delivery',
      label: (supplier.shortName || supplier.code) + ' ' + t('purchase.delivery'),
      children: <InventoryOrder supplierId={supplier.id} />,
    }
  })

  return <CustomTabPane<Supplier> defaultKey={'list'} defaultTabs={[
    {
      key: 'list',
      label: t("purchase.customerList"),
      children: <CustomerTable />,
      closable: false,
    },
  ]} onOpens={(info) => keyObj(info)} />
}

export default PurchaseHome;